// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UpgradePlanpopup_upgrade_image__aHgOk {
  width: 110% !important;
  height: 344px;
  padding: 0;
}

.UpgradePlanpopup_subscription_image__lSvPh {
  height: 300px;
  width: 90%;
}
.UpgradePlanpopup_content_container__6hrBO {
  font-size: 22px !important;
  height: 600px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 21px;
  text-align: center;
}

.UpgradePlanpopup_MuiButtonBaseRoot__qaLPw {
  text-transform: 'none';
  border-radius: 0 !important;
  height: 89px;
  width: 340px;
}

.UpgradePlanpopup_MuiButtonBaseRoot__qaLPw:hover {
  background-color: var(--color-theme-lightblue) !important;
}

.UpgradePlanpopup_bold_text__3jjTH {
  font-size: 22px !important;
  font-weight: 600;
}

.UpgradePlanpopup_regular_text__RxP66 {
  font-size: 22px !important;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/popups/UpgradePlanPopup/UpgradePlanpopup.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;AACA;EACE,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".upgrade_image {\n  width: 110% !important;\n  height: 344px;\n  padding: 0;\n}\n\n.subscription_image {\n  height: 300px;\n  width: 90%;\n}\n.content_container {\n  font-size: 22px !important;\n  height: 600px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 21px;\n  text-align: center;\n}\n\n.MuiButtonBaseRoot {\n  text-transform: 'none';\n  border-radius: 0 !important;\n  height: 89px;\n  width: 340px;\n}\n\n.MuiButtonBaseRoot:hover {\n  background-color: var(--color-theme-lightblue) !important;\n}\n\n.bold_text {\n  font-size: 22px !important;\n  font-weight: 600;\n}\n\n.regular_text {\n  font-size: 22px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"upgrade_image": `UpgradePlanpopup_upgrade_image__aHgOk`,
	"subscription_image": `UpgradePlanpopup_subscription_image__lSvPh`,
	"content_container": `UpgradePlanpopup_content_container__6hrBO`,
	"MuiButtonBaseRoot": `UpgradePlanpopup_MuiButtonBaseRoot__qaLPw`,
	"bold_text": `UpgradePlanpopup_bold_text__3jjTH`,
	"regular_text": `UpgradePlanpopup_regular_text__RxP66`
};
export default ___CSS_LOADER_EXPORT___;
